import React, { Component } from 'react';

class RadioButton extends Component {
    render() {
        let className = "pretty";
        if(this.props.full) className = className + " full";
        return (
            <div className={className}>
                <input onChange={this.props.onChange} type={this.props.type} name={this.props.name} checked={this.props.selected} value={this.props.value} />
                <div className={this.props.shape}></div>
                <label>{this.props.text}</label>
            </div>
        );
    }
}

RadioButton.propTypes = {
    //myProp: PropTypes.type.isRequired
};

export default RadioButton;


// WEBPACK FOOTER //
// ./src/components/RadioButton.js